function initializeCarousels() {
  const carousels = document.querySelectorAll(".embla");

  if (typeof EmblaCarousel === "undefined") {
    console.warn("EmblaCarousel not ready. Retrying...");
    return false;
  }

  carousels.forEach((carouselEl, index) => {
    const viewport = carouselEl.querySelector(".embla__viewport");
    const slides = carouselEl.querySelectorAll(".embla__slide");

    if (!viewport || slides.length === 0) {
      console.warn(`Carousel ${index + 1} skipped: missing viewport or slides.`);
      return;
    }

    const options = {
      loop: carouselEl.dataset.loop === "true" || false,
      align: carouselEl.dataset.align || "center",
      axis: carouselEl.dataset.axis || "x",
      skipSnaps: carouselEl.dataset.skipSnaps === "true" || false,
      duration: parseFloat(carouselEl.dataset.speed) || 25,
      dragFree: carouselEl.dataset.dragFree === "true" || false,
      containScroll: carouselEl.dataset.containScroll || "trimSnaps",
      dragThreshold: 10,
      watchDrag: true,
    };

    const embla = EmblaCarousel(viewport, options);


    // ADDING EMBLA OBECT TO THE CAROUSEL
    carouselEl.embla = embla;

    // Dots navigation logic
    const dots = carouselEl.parentElement.querySelectorAll(".carousel-bullet");
    if (dots.length) {
      const activateDot = (idx) => {
        dots.forEach((dot, i) => dot.classList.toggle("active", i === idx));
      };
      embla.on("select", () => activateDot(embla.selectedScrollSnap()));
      activateDot(embla.selectedScrollSnap());
      dots.forEach((dot, i) => dot.addEventListener("click", () => embla.scrollTo(i)));
    }

    // --- Special handling for shoppable video carousel ---
    if (carouselEl.dataset.carousel === "shoppable-videos") {
      let isCarouselActive = false;
      let currentVideo = null;

      function createAndPlayVideo(slide) {
        const videoSrc = slide.dataset.videoSrc;
        const thumb = slide.querySelector('img');

        if (!videoSrc || !thumb) return;

        // Create video element dynamically
        const video = document.createElement('video');
        video.className = 'slide-video';
        video.src = videoSrc;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.style.position = 'absolute';
        video.style.top = '0';
        video.style.left = '0';
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        video.style.zIndex = '5';

        // Append video and hide thumbnail
        slide.querySelector('.shoppable-video-thumb').appendChild(video);
        

        video.load();
        video.play().then(() => {
          // Fade in video smoothly after it starts playing
          setTimeout(() => {
            video.style.opacity = '1';
          }, 100);
        }).catch(() => {});

        return video;
      }

      function removeVideoShowThumbnail(slide) {
        const video = slide.querySelector('.slide-video');
        const thumb = slide.querySelector('img');

        if (video) {
          video.style.opacity = '0';
          setTimeout(() => {
            video.pause();
            video.remove();
          }, 300);
        }
        if (thumb) {
          thumb.style.opacity = '1';
        }
      }

      function handleSlideChange() {
        if (!isCarouselActive) return;
        const activeIndex = embla.selectedScrollSnap();

        slides.forEach((slide, i) => {
          if (i === activeIndex) {
            if (!slide.querySelector('.slide-video')) {
              currentVideo = createAndPlayVideo(slide);
            }
          } else {
            removeVideoShowThumbnail(slide);
          }
        });
      }

      function stopAllVideos() {
        slides.forEach(slide => removeVideoShowThumbnail(slide));
        currentVideo = null;
      }

      // Intersection Observer to detect carousel visibility
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            isCarouselActive = true;
            handleSlideChange();
          } else {
            isCarouselActive = false;
            stopAllVideos();
          }
        });
      }, { threshold: 0.3 });

      observer.observe(carouselEl);

      embla.on('select', handleSlideChange);
    }

    embla.on("init", () => console.log(`Embla ${index + 1} initialized.`));
  });

  return true;
}

// Loader with retry fallback
(function waitForEmbla() {
  let attempts = 0;
  const maxAttempts = 50;
  const retryDelay = 100;

  function tryInit() {
    const success = initializeCarousels();
    if (!success && attempts < maxAttempts) {
      attempts++;
      setTimeout(tryInit, retryDelay);
    } else if (attempts >= maxAttempts) {
      console.error("EmblaCarousel failed to load after max retries.");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInit);
  } else {
    tryInit();
  }
})();






// function initializeCarousels() {
//   const carousels = document.querySelectorAll(".embla");

//   if (typeof EmblaCarousel === "undefined") {
//     console.warn("EmblaCarousel not ready. Retrying...");
//     return false;
//   }

//   carousels.forEach((carouselEl, index) => {
//     const viewport = carouselEl.querySelector(".embla__viewport");
//     const slides = carouselEl.querySelectorAll(".embla__slide");

//     if (!viewport || slides.length === 0) {
//       console.warn(`Carousel ${index + 1} skipped: missing viewport or slides.`);
//       return;
//     }

//     const options = {
//       loop: carouselEl.dataset.loop === "true" || false,
//       align: carouselEl.dataset.align || "center",
//       skipSnaps: carouselEl.dataset.skipSnaps === "true" || false,
//       duration: parseFloat(carouselEl.dataset.speed) || 25,
//       dragFree: carouselEl.dataset.dragFree === "true" || false,
//       containScroll: carouselEl.dataset.containScroll || "trimSnaps",
//       dragThreshold: 10,
//       watchDrag: true,
//     };

//     const embla = EmblaCarousel(viewport, options);

//     // Dots navigation logic
//     const dots = carouselEl.parentElement.querySelectorAll(".carousel-bullet");
//     if (dots.length) {
//       const activateDot = (idx) => {
//         dots.forEach((dot, i) => dot.classList.toggle("active", i === idx));
//       };
//       embla.on("select", () => activateDot(embla.selectedScrollSnap()));
//       activateDot(embla.selectedScrollSnap());
//       dots.forEach((dot, i) => dot.addEventListener("click", () => embla.scrollTo(i)));
//     }

//     // --- Special handling for shoppable video carousel ---
//     if (carouselEl.dataset.carousel === "shoppable-videos") {
//       let isCarouselActive = false;
//       let currentVideo = null;

//       function createAndPlayVideo(slide) {
//         const videoSrc = slide.dataset.videoSrc;
//         const thumb = slide.querySelector('img');

//         if (!videoSrc || !thumb) return;

//         // Create video element dynamically
//         const video = document.createElement('video');
//         video.className = 'slide-video';
//         video.src = videoSrc;
//         video.muted = true;
//         video.loop = true;
//         video.playsInline = true;
//         video.preload = 'metadata';
//         video.style.position = 'absolute';
//         video.style.top = '0';
//         video.style.left = '0';
//         video.style.width = '100%';
//         video.style.height = '100%';
//         video.style.objectFit = 'cover';
//         video.style.zIndex = '5';

//         // Append video and hide thumbnail
//         slide.querySelector('.shoppable-video-thumb').appendChild(video);
        

//         video.load();
//         video.play().then(() => {
//           // Fade in video smoothly after it starts playing
//           setTimeout(() => {
//             video.style.opacity = '1';
//           }, 100);
//         }).catch(() => {});

//         return video;
//       }

//       function removeVideoShowThumbnail(slide) {
//         const video = slide.querySelector('.slide-video');
//         const thumb = slide.querySelector('img');

//         if (video) {
//           video.style.opacity = '0';
//           setTimeout(() => {
//             video.pause();
//             video.remove();
//           }, 300);
//         }
//         if (thumb) {
//           thumb.style.opacity = '1';
//         }
//       }

//       function handleSlideChange() {
//         if (!isCarouselActive) return;
//         const activeIndex = embla.selectedScrollSnap();

//         slides.forEach((slide, i) => {
//           if (i === activeIndex) {
//             if (!slide.querySelector('.slide-video')) {
//               currentVideo = createAndPlayVideo(slide);
//             }
//           } else {
//             removeVideoShowThumbnail(slide);
//           }
//         });
//       }

//       function stopAllVideos() {
//         slides.forEach(slide => removeVideoShowThumbnail(slide));
//         currentVideo = null;
//       }

//       // Intersection Observer to detect carousel visibility
//       const observer = new IntersectionObserver((entries) => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             isCarouselActive = true;
//             handleSlideChange();
//           } else {
//             isCarouselActive = false;
//             stopAllVideos();
//           }
//         });
//       }, { threshold: 0.3 });

//       observer.observe(carouselEl);

//       embla.on('select', handleSlideChange);
//     }

//     embla.on("init", () => console.log(`Embla ${index + 1} initialized.`));
//   });

//   return true;
// }

// // Loader with retry fallback
// (function waitForEmbla() {
//   let attempts = 0;
//   const maxAttempts = 50;
//   const retryDelay = 100;

//   function tryInit() {
//     const success = initializeCarousels();
//     if (!success && attempts < maxAttempts) {
//       attempts++;
//       setTimeout(tryInit, retryDelay);
//     } else if (attempts >= maxAttempts) {
//       console.error("EmblaCarousel failed to load after max retries.");
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", tryInit);
//   } else {
//     tryInit();
//   }
// })();

